import * as Sentry from '@sentry/react';

import { runtimeConfig } from 'runtimeConfig';

if (runtimeConfig.sentryDsn) {
  Sentry.init({
    dsn: runtimeConfig.sentryDsn,
    environment: runtimeConfig.sentryEnvironment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    release: import.meta.env.VITE_SENTRY_RELEASE,
  });
}
